function getApiKeyFromStorage() {
  //return $.cookie('APIKEY');
  return sessionStorage.getItem("apiKey");
}
function getApiTokenFromStorage() {
  //return $.cookie('SITEADMINTOKEN');
  return sessionStorage.getItem("apiToken");
}
